const backToHomePage = () => {
  window.location.href = '/';
};

const logoutRedirect = () => {
  localStorage.clear();
  window.location.href = '/logout';
};

const reload = () => {
  window.location.reload();
};

const ERR_GENERIC =
  'Oops, something went wrong! Please contact your Alef Administrator';
const ERR_NETWORK =
  'Oops, something went wrong with the network! Please click on the reload button to resume the assignment';
const ERR_AUTHORIZATION =
  'Yay, you’re back! Click ‘Login Again’ to continue, since your session has expired';
const ERR_ASSIGNMENT_NOT_FOUND = "Sorry!, This assignment doesn't exist";

const ERROR_MESSAGES = {
  GENERIC: {
    message: ERR_GENERIC,
    action: 'Back to Home',
    callback: backToHomePage,
  },
  AUTHORIZATION: {
    message: ERR_AUTHORIZATION,
    action: 'Login Again',
    callback: logoutRedirect,
  },
  NETWORK: { message: ERR_NETWORK, action: 'Reload', callback: reload },
  4001: {
    message: ERR_ASSIGNMENT_NOT_FOUND,
    action: 'Back to Home',
    callback: backToHomePage,
  },
};

const ERROR_CODES = {
  GENERIC: 'GENERIC',
  AUTHORIZATION: 'AUTHORIZATION',
  NETWORK: 'NETWORK',
  4001: '4001',
};

export { ERROR_MESSAGES, ERROR_CODES, logoutRedirect };
